<template>
  <div
    class="rounded-circle"
    :style="
      `background:url(` +
      photoUrl +
      `) center/cover;
                    padding: 50%`
    "
  ></div>
</template>

<script>
export default {
  props: {
    photoUrl: {
      type: String,
      required: true,
    },
  },
}
</script>

<style scoped></style>
